import PostList from '@linc-technologies/linced-common/components/post-list';
import PostStatus from '@linc-technologies/linced-common/enums/post-status';

export default class PublishablePostList extends PostList {
  PostStatus = PostStatus;
}
